<template>
  <app-layout>
    <v-card class="ma-3">
      <v-card-title>
        <h2>Solicitudes</h2>
      </v-card-title>
      <v-card-text>
        <laboral-requests :admin-view="true"></laboral-requests>
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import LaboralRequests from '@/modules/laboral/components/LaboralRequests.vue';
export default {
  components: { LaboralRequests, AppLayout },
  computed: {},
};
</script>

<style></style>
